export const DELIMITER_CHARS = [',', ' ', ';', '\n', '\t']
export const DELIMITER_CHARS_REGEXP = new RegExp(DELIMITER_CHARS.join('|'))
